import React from 'react';

/**
 * Botao — ação do usuário, sempre com verbo (README: referencias/design-system/componentes/Botao).
 *
 * variante: 'primario' | 'secundario' | 'fantasma' | 'perigo' | 'inverso' | 'contorno-inverso'
 * tamanho:  'padrao' | 'sm'
 * carregando: mostra o giro e bloqueia o clique (aria-busy).
 * icone: nome de Material Symbols, antes do texto. Sem texto, exige `rotulo` (vira aria-label).
 */
const Botao = React.forwardRef(function Botao({
  variante = 'primario',
  tamanho = 'padrao',
  icone,
  carregando = false,
  rotulo,
  type = 'button',
  className = '',
  pilula = false,
  item = false,
  children,
  disabled = false,
  ...resto
}, ref) {
  // Mesmo elemento, outra forma: `pilula` é o filtro (sj-escolha); `item` é linha de menu (sj-lista__item).
  const formaPropria = pilula ? 'sj-escolha' : item ? 'sj-lista__item' : null;
  const classes = formaPropria
    ? [formaPropria, className].filter(Boolean).join(' ')
    : [
      'sj-btn',
      `sj-btn--${variante}`,
      tamanho === 'sm' ? 'sj-btn--sm' : '',
      !children && icone ? 'sj-btn--icone' : '',
      className,
    ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      aria-busy={carregando || undefined}
      aria-label={!children ? rotulo : undefined}
      disabled={carregando || disabled}
      {...resto}
    >
      {icone && <span className="sj-icone" aria-hidden="true">{icone}</span>}
      {children}
    </button>
  );
});

export default Botao;
